import trTR from 'antd/locale/tr_TR';
import type { Locale } from 'antd/es/locale';
import type { AppLanguage } from './config';

/**
 * AntD ConfigProvider locale + dayjs locale id per app language. When English
 * is added, register `en_US` / 'en' here and the provider switches automatically.
 */
export const ANTD_LOCALES: Record<AppLanguage, Locale> = {
  tr: trTR,
};

export const DAYJS_LOCALES: Record<AppLanguage, string> = {
  tr: 'tr',
};
